var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},_vm._l((_vm.config.list),function(item,itemIndex){return _c('div',{key:itemIndex,staticClass:"tab-item",class:{'active': itemIndex === _vm.config.currentIndex},on:{"click":function($event){return _vm.handleItemClick(item, itemIndex)}}},[_vm._v(_vm._s(item[_vm.labelKey]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }